import { configureStore } from '@reduxjs/toolkit'
import quizReducer from 'app/QuizSlice'
import questionsReducer from 'app/QuestionsSlice'

export const store = configureStore({
  reducer: {
    quiz: quizReducer,
    questions: questionsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
